import carIcon from '../mixins/car.js'
import find from 'lodash.find'
import api from '../api'

export default {
  methods: {
    drawCars () {
      var self = this
      self.removeCars()

      if (self.repeater) {
        clearInterval(self.repeater)
        self.repeater = null
      }

      if (self.shouldDrawLiveCars()) {
        self.getCars()
        self.repeater = setInterval(function () {
          self.updateCars()
        }, self.update_interval)
      } else {
        clearInterval(self.repeater)
      }
    },
    shouldDrawLiveCars () {
      var self = this
      var liveCarsArray = [2]
      return liveCarsArray.includes(self.campaign.status)
    },
    getCars () {
      var self = this

      self.carsLoading = true

      return api.getCampaignLive(self.campaign.id)
      .catch(() => alert('Cars data error'))
      .then((r) => {
        var cars = r.data.data
        for (var i = 0; i < cars.length; i++) {
          var car = self.drawCar(cars[i])
          self.cars.push(car)
        }
        self.carsLoading = false
      })
    },
    drawCar (car) {
      var self = this
      var markerIcon = this.getMarker(car.rotation)
      var map = self.$refs.mainMap.$mapObject
      var carMarker = new window.google.maps.Marker({
        map: map,
        position: {lat: car.latitude, lng: car.longitude},
        icon: markerIcon
      })
      carMarker.addListener('click', function () {
        console.log(car.id)
      })
      carMarker.set('id', car.id)
      carMarker.set('timer', null)
      return carMarker
    },

    getMarker (rotation) {
      return {
        path: carIcon,
        fillColor: '#01b1ec',
        fillOpacity: 1,
        scale: 1,
        strokeWeight: 0,
        size: new window.google.maps.Size(24, 50),
        origin: new window.google.maps.Point(0, 0),
        anchor: new window.google.maps.Point(12, 25),
        rotation: rotation
      }
    },
    updateCars () {
      var self = this

      return api
      .getCampaignLive(self.campaign.id)
      .catch(() => alert('Cars data error'))
      .then((r) => {
        var cars = r.data.data
        for (var i = 0; i < cars.length; i++) {
          self.updateCar(cars[i])
        }
      })
    },
    updateCar (car) {
      var id = car.id
      var self = this

      var storedCar = find(self.cars, function (o) {
        return o.id === id
      })
      clearTimeout(storedCar.timer)
      var direction = {
        lng: car.longitude - storedCar.getPosition().lng(),
        lat: car.latitude - storedCar.getPosition().lat(),
        rotation: car.rotation - storedCar.icon.rotation
      }
      this.setSmoothPosition(0, storedCar, direction)
    },
    setSmoothPosition (i, start, direction) {
      var self = this
      var newLocation = {
        lat: start.getPosition().lat() + (1 / self.smoother) * direction.lat,
        lng: start.getPosition().lng() + (1 / self.smoother) * direction.lng,
        rotation: start.icon.rotation + (1 / self.smoother) * direction.rotation
      }
      start.setPosition(newLocation)
      start.setIcon(this.getMarker(newLocation.rotation))

      if (i < self.smoother - 1) {
        i++
        start.timer = setTimeout(function () {
          self.setSmoothPosition(i, start, direction)
        }, self.update_interval / self.smoother)
      }
    },
    removeCars () {
      while (this.cars.length) {
        var car = this.cars.shift()
        car.setMap(null)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/drawCars.js